module.exports = __webpack_public_path__ + "img/1582661769.b88ee6b4.jpg";